import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

interface IdentityFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function IdentityFields({
  profile,
  setProfile,
  readOnly,
  loading
}: IdentityFieldsProps) {
  const { t } = useTranslation(["talent", "common"]);

  return (
    <>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.given_name.label")}{" "}
          {t("forms.common.validation.required_indicator")}
        </label>
        <Input
          id="given_name"
          disabled={readOnly}
          loading={loading}
          value={profile.given_name}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({
              ...prev,
              given_name: val
            }));
          }}
          placeholder={t(
            "forms.sections.personal_data.fields.given_name.placeholder"
          )}
          required
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.family_name.label")}{" "}
          {t("forms.common.validation.required_indicator")}
        </label>
        <Input
          id="family_name"
          disabled={readOnly}
          loading={loading}
          value={profile.family_name}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({
              ...prev,
              family_name: val
            }));
          }}
          placeholder={t(
            "forms.sections.personal_data.fields.family_name.placeholder"
          )}
          required
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.email.label")}{" "}
          {t("forms.common.validation.required_indicator")}
        </label>
        <Input
          id="email"
          disabled={readOnly}
          loading={loading}
          value={profile.email}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, email: val }));
          }}
          placeholder={t(
            "forms.sections.personal_data.fields.email.placeholder"
          )}
          required
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.personal_data.fields.phone.label")}
        </label>
        <Input
          id="phone"
          disabled={readOnly}
          loading={loading}
          value={profile.phone}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, phone: val }));
          }}
          placeholder={t(
            "forms.sections.personal_data.fields.phone.placeholder"
          )}
        />
      </div>
    </>
  );
}
